import React, { useEffect, useState } from "react";
import {
  getCommissionsStructures,
  selectCommissionStructure,
} from "../../../../slices/national/thunk";
import { useDispatch } from "react-redux";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Input,
} from "reactstrap";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";

const SelectCommissionStructureModal = ({
  open,
  setOpen,
  userProfile,
  currentUser,
  onRefresh,
}) => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const currentCommissionUser = userProfile.customCommissionStructureId;

  const [loading, setLoading] = useState(false);
  const [commissionsStructure, setCommissionsStructure] = useState([]);

  const toggle = () => setOpen(!open);

  const fetchCommissionStructures = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getCommissionsStructures({ id: currentUser.id })
      );

      if (response && !response.error) {
        setCommissionsStructure(response.payload);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) fetchCommissionStructures();
  }, [open]);

  const [selectedCommission, setSelectedCommission] = useState(
    currentCommissionUser
  );
  const [tempSelectedCommission, setTempSelectedCommission] = useState(
    currentCommissionUser
  );

  const selectedStructure =
    commissionsStructure?.custom?.find(
      (structure) => structure.id === currentCommissionUser
    ) || commissionsStructure?.default;

  const handleSelectCommissionStructure = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        selectCommissionStructure({
          nationalId: currentUser.id,
          userId: id,
          commissionStructureId: tempSelectedCommission,
        })
      );

      if (response && !response.error) {
        Swal.fire({
          title: "Success!",
          text: "Commission structure selected successfully",
          icon: "success",
          confirmButtonText: "OK",
        });
        onRefresh();
        toggle();
      } else {
        Swal.fire({
          title: "Error!",
          text: "Error selecting commission structure",
          icon: "error",
          confirmButtonText: "OK",
        });
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: "Error selecting commission structure",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const sortedCommissionStructures = [
    ...(selectedStructure?.id !== commissionsStructure?.default?.id
      ? [selectedStructure]
      : []),
    ...(commissionsStructure?.custom?.filter(
      (structure) =>
        structure.id !== selectedStructure?.id &&
        structure.id !== commissionsStructure?.default?.id
    ) || []),
  ];

  console.log("selected structure", selectedStructure);
  console.log("temp selected structure", tempSelectedCommission);

  return (
    <>
      <Modal isOpen={open} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Select Commission Structure</ModalHeader>
        <ModalBody>
          {loading ? (
            <div className="d-flex align-items-center justify-content-center mt-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <Input
              type="select"
              id="commissionSelect"
              value={tempSelectedCommission || ""}
              onChange={(e) => {
                setTempSelectedCommission(e.target.value);
                setSelectedCommission(e.target.value);
              }}
            >
              <option value={commissionsStructure?.default?.id || "default"}>
                Default Commission Structure
              </option>
              {sortedCommissionStructures.map(
                (structure) =>
                  structure && (
                    <option key={structure.id} value={structure.id}>
                      {structure.name}
                    </option>
                  )
              )}
            </Input>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            disabled={loading}
            onClick={handleSelectCommissionStructure}
            color="primary"
          >
            Select
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SelectCommissionStructureModal;
